<template lang="pug">
    div.resolve-order
        el-dialog(
            :title="`工单处理：${getWorkOrderStatus}`"
            :visible.sync="dialogData.show"
            :close-on-click-modal="false"
            width="865px"
            center
        )
            div.resolve-order-content(v-loading="loading")
                div.base-info
                    div.info-item
                        div.item-label 车牌号：
                        div.item-value {{ detailData.plateNumber | fieldVaild }}
                    div.info-item
                        div.item-label 联系人：
                        div.item-value {{ detailData.contactName | fieldVaild }} {{ detailData.contactPhone }}
                    div.info-item
                        div.item-label 车架号：
                        div.item-value {{ detailData.vin | fieldVaild }}
                    div.info-item
                        div.item-label 车型：
                        div.item-value {{ detailData.vehicleModel | fieldVaild }}
                    div.info-item
                        div.item-label 当前里程数(km)：
                        div.item-value {{ detailData.currentMileage | fieldVaild }}
                    div.info-item
                        div.item-label 工单编号：
                        div.item-value {{ detailData.id | fieldVaild }}
                div(style="flex: 1")
                    div.tab-header
                        div.tab-item(
                            v-for="tab in stepTabs"
                            :key="tab.value"
                            v-show="tab.show"
                            :class="{'active': currentStep === tab.value}"
                            @click="clickTab(tab)")
                            svg-icon.icon(icon-class="step-complete" v-if="isStepComplete(tab)")
                            svg-icon.icon(icon-class="step-waiting" v-if="!isStepComplete(tab)")
                            span {{ tab.name }}
                            div.blue-border
                    template(v-if="orderStatus === 'CHECKING'")
                        pre-check(v-show="currentStep === 'preCheck'" ref="preCheckForm" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                        maintenance-check(v-show="currentStep === 'maintenanceCheck' || currentStep === 'autox3MaintenanceCheck'"
                            ref="maintenanceCheckForm" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                    template(v-if="orderStatus === 'UNDER_CONSTRUCTION'")
                        component-car(v-show="currentStep === 'component'" ref="componentForm" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                        template(v-if="isAutoX3Maintenance")
                            auto-maintenance(v-show="currentStep === 'autox3Maintenance'")
                        template(v-if="!isAutoX3Maintenance")
                            maintenance(v-show="currentStep === 'maintenance'" ref="maintenanceForm" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                            spray-paint(v-show="currentStep === 'sprayPaint'" ref="sprayPaintForm" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                            vehicle-painting(v-show="currentStep === 'vehiclePainting'" ref="vehiclePaintingForm" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
                    template(v-if="orderStatus === 'IN_DELIVERY'")
                        deliver-maintenance(v-show="currentStep === 'deliver'" ref="deliverForm" :loading="loading" :detail-data="detailData" @submit="submitData" @viewImg="viewImg")
        image-viewer(
            v-if="showViewer"
            :showViewer.sync="showViewer"
            :currentUrl="currentUrl"
            :urlList="urlList"
        )
</template>

<script>
import { mapState } from 'vuex';
import { workOrderApis } from '@/api';
import { handleParameter } from '@/filters';
import PreCheck from './resolveForm/PreCheck.vue';
import MaintenanceCheck from './resolveForm/MaintenanceCheck.vue';
import AutoMaintenance from './resolveForm/AutoMaintenance.vue';
import SprayPaint from './resolveForm/SprayPaint.vue';
import Maintenance from './resolveForm/Maintenance.vue';
import VehiclePainting from './resolveForm/VehiclePainting.vue';
import ComponentCar from './resolveForm/Component.vue';
import DeliverMaintenance from './resolveForm/DeliverMaintenance.vue';
import ImageViewer from '@/components/ImageViewer.vue';

export default {
    name: 'ResolveOrderMaintain',
    components: {
        PreCheck,
        MaintenanceCheck,
        AutoMaintenance,
        Maintenance,
        SprayPaint,
        VehiclePainting,
        ComponentCar,
        DeliverMaintenance,
        ImageViewer,
    },
    props: {
        dialogData: {
            type: Object,
            default() {
                return {
                    show: false,
                    id: '',
                };
            },
        },
    },
    data() {
        return {
            loading: false,
            detailData: {},
            // 车辆监测环节
            checkTabs: [
                { name: '车辆预检', value: 'preCheck', show: true },
                { name: '保养检测', value: 'maintenanceCheck', show: true },
            ],
            autoCheckTabs: [
                { name: '车辆预检', value: 'preCheck', show: true },
                { name: '保养检测', value: 'autox3MaintenanceCheck', show: true },
            ],
            // 车辆施工环节
            workTabs: [
                { name: '配件处理', value: 'component', show: false },
                { name: '车辆保养', value: 'maintenance', show: true },
                { name: '钣金施工', value: 'sprayPaint', show: false },
                { name: '车辆喷漆', value: 'vehiclePainting', show: false },
            ],
            // 车辆施工环节(智能保养)
            autoWorkTabs: [
                { name: '配件处理', value: 'component', show: false },
                { name: '车辆保养', value: 'autox3Maintenance', show: true },
            ],
            // 车辆交付环节
            payTabs: [
                { name: '车辆交付', value: 'deliver', show: true },
            ],
            currentStep: '', // 当前处理环节

            showViewer: false,
            urlList: [],
            currentUrl: '',
            initStatus: '',
        };
    },
    computed: {
        ...mapState('user', [
            'userInfo',
        ]),
        orderStatus() {
            return this.detailData.orderStatus;
        },
        getWorkOrderStatus() {
            let str = '';
            switch (this.detailData.orderStatus) {
            case 'CHECKING':
                str = '检测中';
                break;
            case 'UNDER_CONSTRUCTION':
                str = '施工中';
                break;
            case 'IN_DELIVERY':
                str = '车辆交付';
                break;
            default:
                break;
            }
            return str;
        },
        stepTabs() {
            if (this.orderStatus === 'CHECKING') return this.isAutoX3MaintenanceCheck ? this.autoCheckTabs : this.checkTabs;
            if (this.orderStatus === 'UNDER_CONSTRUCTION') return this.isAutoX3Maintenance ? this.autoWorkTabs : this.workTabs;
            if (this.orderStatus === 'IN_DELIVERY') return this.payTabs;
            return [];
        },
        isAutoX3MaintenanceCheck() {
            return (this.detailData.upcomingList && this.detailData.upcomingList.includes('AUTOX3_MAINTENANCE_CHECK')) || this.detailData.autox3MaintenanceCheck;
        },
        isAutoX3Maintenance() {
            return (this.detailData.upcomingList && this.detailData.upcomingList.includes('AUTOX3_MAINTENANCE')) || this.detailData.autox3Maintenance;
        },
        checkData() {
            return this.isAutoX3MaintenanceCheck ? this.detailData.autox3MaintenanceCheck : this.detailData.maintenanceCheck;
        },
    },
    watch: {
        currentStep(val) {
            if (val) {
                this.handleViewParameterFun(val);
            }
        },
    },
    mounted() {
        this.getOrderDetail();
    },
    methods: {
        clickTab(tab) {
            this.currentStep = tab.value;
        },
        isStepComplete(tab) {
            const stepData = this.detailData[tab.value];
            if (stepData && ['COMMIT', 'IGNORE'].includes(stepData.itemStatus)) return true;
            return false;
        },
        async getOrderDetail(itemStatus) {
            try {
                this.loading = true;
                const { data } = await workOrderApis.getWorkOrderDetail(this.dialogData.id);
                this.detailData = data;
                if (!this.initStatus || this.initStatus === data.orderStatus) {
                    this.setCurrentStep(itemStatus);
                    this.initStatus = data.orderStatus;
                } else {
                    this.handleCancel();
                }
            } catch (error) {
                this.detailData = {};
                throw new Error(error);
            } finally {
                this.loading = false;
            }
        },
        setCurrentStep(itemStatus) {
            const map = {
                CHECKING: ['preCheck', this.isAutoX3MaintenanceCheck ? 'autox3MaintenanceCheck' : 'maintenanceCheck'],
                UNDER_CONSTRUCTION: [this.isAutoX3Maintenance ? 'autox3Maintenance' : 'maintenance'],
                IN_DELIVERY: ['deliver'],
            };
            if (this.detailData.orderStatus === 'UNDER_CONSTRUCTION' && this.checkData && this.checkData.content) {
                if (this.isAutoX3Maintenance) {
                    this.autoWorkTabs[0].show = Boolean(this.checkData.content.buyComponents);
                    if (this.checkData.content.buyComponents) map.UNDER_CONSTRUCTION.unshift('component');
                } else {
                    this.workTabs[0].show = Boolean(this.checkData.content.buyComponents);
                    this.workTabs[2].show = Boolean(this.checkData.content.sprayPaint);
                    this.workTabs[3].show = Boolean(this.checkData.content.vehiclePainting);
                    if (this.checkData.content.buyComponents) map.UNDER_CONSTRUCTION.unshift('component');
                    if (this.checkData.content.sprayPaint) map.UNDER_CONSTRUCTION.push('sprayPaint');
                    if (this.checkData.content.vehiclePainting) map.UNDER_CONSTRUCTION.push('vehiclePainting');
                }
            }
            if (itemStatus === 'STASH') return;
            const arr = map[this.orderStatus];
            for (let i = 0; i < arr.length; i++) {
                if (!this.detailData[arr[i]] || this.detailData[arr[i]].itemStatus === 'STASH') {
                    this.currentStep = arr[i];
                    break;
                }
            }
        },
        handleCancel() {
            this.dialogData.show = false;
        },
        async submitData($event) {
            if (this.loading === true) return;
            const formData = JSON.parse(JSON.stringify($event.data));
            const itemStatus = $event.type;
            const itemName = formData.stepName;
            delete formData.stepName;
            this.handleParameterFun(itemStatus, itemName);
            try {
                this.loading = true;
                const { code } = await workOrderApis.resolveWorkOrder(this.dialogData.id, {
                    content: itemStatus === 'IGNORE' ? null : formData,
                    itemStatus,
                    itemName,
                });
                if (code === 0) {
                    this.$message({
                        message: `${itemStatus === 'STASH' ? '保存成功' : '提交成功'}`,
                        type: 'success',
                    });
                    if (itemStatus !== 'STASH') {
                        this.getOrderDetail(itemStatus);
                        this.$emit('refresh');
                    }
                }
            } catch (error) {
                throw new Error(error);
            } finally {
                this.loading = false;
            }
        },
        viewImg($event) {
            this.currentUrl = $event.url;
            this.urlList = $event.urls;
            this.showViewer = true;
        },
        handleParameterFun(itemStatus, itemName) {
            const typeMap = {
                IGNORE: '跳过',
                STASH: '保存',
                COMMIT: '提交',
            };
            const nameMap = {
                COMPONENT: '配件处理',
                DELIVER: '车辆交付',
                MAINTENANCE: '车辆保养',
                MAINTENANCE_CHECK: '保养检测',
                PRE_CHECK: '车辆预检',
                SPRAY_PAINT: '钣金施工',
                VEHICLE_PAINTING: '车辆喷漆',
            };
            handleParameter({
                trackKey: 'workorderservice_maintenance_maintenanceaction_click',
                attr: {
                    shop_id: this.userInfo.lastLoginOrgId,
                    account_type: this.userInfo.orgType,
                    xyt_id: this.userInfo.id,
                    workorder_id: this.dialogData.id,
                    dispose_name: nameMap[itemName],
                    action_type: typeMap[itemStatus],
                },
            });
        },
        handleViewParameterFun(itemName) {
            const nameMap = {
                component: '配件处理',
                maintenanceCheck: '保养检测',
                autox3MaintenanceCheck: '保养检测',
                deliver: '车辆交付',
                preCheck: '车辆预检',
                maintenance: '车辆保养',
                autox3Maintenance: '车辆保养',
                sprayPaint: '钣金施工',
                vehiclePainting: '车辆喷漆',
            };
            handleParameter({
                trackKey: 'workorderservice_maintenance_maintenancedisposedialog_popup',
                attr: {
                    shop_id: this.userInfo.lastLoginOrgId,
                    account_type: this.userInfo.orgType,
                    xyt_id: this.userInfo.id,
                    workorder_id: this.dialogData.id,
                    dispose_name: nameMap[itemName],
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
    .resolve-order {
        &-content {
            display: flex;
            .base-info {
                width: 280px;
                min-height: 350px;
                background: #F9F9F9;
                font-size: 14px;
                font-weight: 400;
                padding: 20px;
                .info-item {
                    display: flex;
                    min-height: 20px;
                    line-height: 20px;
                    margin-bottom: 20px;
                    .item-label {
                        color: #999999;
                        white-space: nowrap;
                    }
                    .item-value {
                        color: #333333;
                    }
                }
            }
            .tab-header {
                width: 100%;
                height: 40px;
                border-bottom: 1px solid rgba(0,0,0,0.06);
                display: flex;
                .tab-item {
                    width: 124px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0,0,0,0.65);
                    font-weight: 400;
                    cursor: pointer;
                    .icon {
                        margin-right: 5px;
                    }
                    &.active {
                        color: #2970FF;
                        font-weight: bolder;
                        position: relative;
                        .blue-border {
                            width: 76px;
                            height: 4px;
                            background: #2970FF;
                            position: absolute;
                            bottom: 0;
                            left: 24px;
                        }
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .resolve-order {
        .dialog-footer {
            display: flex;
            width: 100%;
            justify-content: center;
        }
        .button {
            margin: 0 25px;
            width: 110px;
        }
        .el-dialog__body {
            padding: 0!important;
        }
        .el-dialog__footer {
            padding: 0 0 20px 0!important;
        }
        .el-form-item__label {
            width: 114px;
            padding: 0;
        }
    }
</style>
